// src/echipe.js
import * as React from "react";
import {
    Create,
    Edit,
    SimpleForm,
    TextInput,
    ReferenceInput,
    SelectInput,
} from "react-admin";

export const EchipaCreate = () => (
    <Create>
        <SimpleForm>
            <TextInput source="nume" label="Nume echipă" />
            <ReferenceInput source="parent" reference="echipe" label="Echipă părinte (opțional)">
                <SelectInput optionText="nume" emptyText="— Fără părinte —" />
            </ReferenceInput>
        </SimpleForm>
    </Create>
);

export const EchipaEdit = () => (
    <Edit>
        <SimpleForm>
            <TextInput source="nume" label="Nume echipă" />
            <ReferenceInput source="parent" reference="echipe" label="Echipă părinte (opțional)">
                <SelectInput optionText="nume" emptyText="— Fără părinte —" />
            </ReferenceInput>
        </SimpleForm>
    </Edit>
);
